import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container card bg-white p-5" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  to: "#topbar",
  class: "card bg-white p-5 mb-4"
}
const _hoisted_5 = { class: "d-flex flex-row align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "m-0"
}
const _hoisted_7 = {
  key: 1,
  class: "m-0"
}
const _hoisted_8 = {
  key: 2,
  class: "m-0"
}
const _hoisted_9 = { class: "ml-auto" }
const _hoisted_10 = {
  key: 0,
  class: "card bg-white p-5"
}
const _hoisted_11 = { class: "container-wide" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-12 col-md-8" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12 col-md-6" }
const _hoisted_16 = { class: "col-12 col-md-6" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12 col-md-8" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-6" }, null, -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12 col-md-6" }
const _hoisted_22 = { class: "col-12 col-md-6" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-12 col-md-6" }
const _hoisted_25 = { class: "col-12 col-md-6" }
const _hoisted_26 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_27 = {
  class: "text-primary",
  href: "https://simap.ted.europa.eu/de/nuts",
  target: "_blank"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-12 col-md-6" }
const _hoisted_30 = { class: "col-12 col-md-6" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-12 col-md-6" }
const _hoisted_33 = { class: "col-12 col-md-6" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-12 col-md-6" }
const _hoisted_36 = { class: "col-12 col-md-6" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-12 col-md-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-6" }, null, -1)
const _hoisted_40 = {
  key: 1,
  class: "card bg-white p-5"
}
const _hoisted_41 = {
  key: 2,
  class: "card bg-white p-5"
}
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col col-lg-4" }
const _hoisted_46 = { class: "m-0 font-weight-bold" }
const _hoisted_47 = { class: "m-0" }
const _hoisted_48 = {
  key: 0,
  class: "m-0"
}
const _hoisted_49 = {
  key: 1,
  class: "m-0"
}
const _hoisted_50 = { class: "m-0" }
const _hoisted_51 = {
  key: 2,
  class: "m-0"
}
const _hoisted_52 = {
  key: 3,
  class: "m-0"
}
const _hoisted_53 = {
  key: 4,
  class: "m-0"
}
const _hoisted_54 = {
  key: 5,
  class: "m-0"
}
const _hoisted_55 = {
  key: 6,
  class: "m-0"
}
const _hoisted_56 = {
  key: 7,
  class: "m-0"
}
const _hoisted_57 = {
  key: 8,
  class: "m-0"
}
const _hoisted_58 = {
  key: 9,
  class: "m-0"
}
const _hoisted_59 = {
  key: 10,
  class: "m-0"
}
const _hoisted_60 = {
  key: 11,
  class: "m-0"
}
const _hoisted_61 = { class: "m-0 font-weight-bold" }
const _hoisted_62 = { class: "m-0" }
const _hoisted_63 = { class: "col col-lg-4" }
const _hoisted_64 = { class: "m-0 font-weight-bold" }
const _hoisted_65 = {
  key: 0,
  class: "m-0"
}
const _hoisted_66 = {
  key: 1,
  class: "m-0"
}
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translate = _resolveComponent("translate")!
  const _component_Button = _resolveComponent("Button")!
  const _component_OrganizationForm = _resolveComponent("OrganizationForm")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createElementBlock("form", {
    class: "container-wide flex-shrink-1 flex-grow-1",
    ref: "organizationFormElement",
    onSubmit: _cache[24] || (_cache[24] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.proceed && _ctx.proceed(...args)), ["prevent","stop"])),
    style: {"overflow":"auto"}
  }, [
    (_ctx.organization.type === 'CLIENT')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(), _createBlock(_Teleport, { to: "#topmenu-buttons" }, [
            _createVNode(_component_Button, {
              type: "submit",
              class: "p-button-success",
              onClick: _ctx.triggerFormSubmit
            }, {
              default: _withCtx(() => [
                _createVNode(_component_translate, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Speichern")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_OrganizationForm, { organization: _ctx.organization }, null, 8, ["organization"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.step === 0)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_6, [
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Unternehmens-Daten")
                      ]),
                      _: 1
                    })
                  ]))
                : (_ctx.step === 1)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_7, [
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Unternehmens-Daten")
                        ]),
                        _: 1
                      })
                    ]))
                  : (_ctx.step === 2)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_8, [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Bestätigung")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.step > 0)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-text bg-white border-primary ml-3",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.step = _ctx.step - 1))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Zurück")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.step < 2 && !_ctx.organization.id)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      type: "submit",
                      class: "p-button-success p-button-text border-success bg-white ml-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_translate, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Weiter")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : (!_ctx.organization.id)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 2,
                        type: "submit",
                        class: "p-button-success ml-3",
                        disabled: !_ctx.rpcClient.isInternalUser && (!_ctx.confirm1 || !_ctx.confirm2)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Absenden")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : (_openBlock(), _createBlock(_component_Button, {
                        key: 3,
                        type: "submit",
                        class: "p-button-success ml-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Speichern")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
              ])
            ])
          ]),
          (_ctx.step === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Unternehmensname'),
                        modelValue: _ctx.organization.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.organization.name) = $event)),
                        modelModifiers: { lazy: true, trim: true },
                        name: "name",
                        autofocus: "",
                        "auto-resize": "",
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Vorname') + ' ' + _ctx.i18n.$gettext('Vertretungsberechtigter'),
                        modelValue: _ctx.organization.contact.givenName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.organization.contact.givenName) = $event)),
                        modelModifiers: { lazy: true, trim: true },
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Nachname') + ' ' + _ctx.i18n.$gettext('Vertretungsberechtigter'),
                        modelValue: _ctx.organization.contact.surName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.organization.contact.surName) = $event)),
                        modelModifiers: { lazy: true, trim: true },
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Straße, Haus-Nr.'),
                        modelValue: _ctx.organization.contact.street,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.organization.contact.street) = $event)),
                        modelModifiers: { lazy: true, trim: true },
                        "auto-resize": "",
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _hoisted_19
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Postleitzahl'),
                        modelValue: _ctx.organization.contact.zip,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.organization.contact.zip) = $event)),
                        modelModifiers: { lazy: true, trim: true },
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Ort'),
                        modelValue: _ctx.organization.contact.city,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.organization.contact.city) = $event)),
                        modelModifiers: { lazy: true, trim: true },
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Land'),
                        modelValue: _ctx.organization.contact.country,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.organization.contact.country) = $event)),
                        modelModifiers: { lazy: true, trim: true },
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      (_ctx.organization.type === 'CLIENT')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createVNode(_component_AnimatedInput, {
                              type: "text",
                              label: _ctx.i18n.$gettext('NUTS Code'),
                              modelValue: _ctx.organization.nutsCode,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.organization.nutsCode) = $event)),
                              modelModifiers: { lazy: true, trim: true },
                              required: ""
                            }, null, 8, ["label", "modelValue"]),
                            _createElementVNode("a", _hoisted_27, [
                              _createVNode(_component_translate, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Link zur NUTS-Code-Suche")
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "email",
                        label: _ctx.i18n.$gettext('E-Mail'),
                        modelValue: _ctx.organization.contact.email,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.organization.contact.email) = $event)),
                        modelModifiers: { lazy: true, trim: true },
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Telefon'),
                        modelValue: _ctx.organization.contact.phone,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.organization.contact.phone) = $event)),
                        modelModifiers: { lazy: true, trim: true },
                        required: ""
                      }, null, 8, ["label", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      (_ctx.organization.contact)
                        ? (_openBlock(), _createBlock(_component_AnimatedInput, {
                            key: 0,
                            type: "text",
                            class: "mb-3",
                            label: _ctx.i18n.$gettext('Fax'),
                            modelValue: _ctx.organization.contact.facsimile,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.organization.contact.facsimile) = $event)),
                            modelModifiers: { lazy: true, trim: true }
                          }, null, 8, ["label", "modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Webseite (URL)'),
                        modelValue: _ctx.organization.contact.url,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.organization.contact.url) = $event)),
                        modelModifiers: { lazy: true, trim: true }
                      }, null, 8, ["label", "modelValue"])
                    ])
                  ]),
                  (_ctx.organization.type === 'CLIENT')
                    ? (_openBlock(), _createBlock(_component_AnimatedInput, {
                        key: 0,
                        type: "text",
                        class: "mb-3",
                        label: _ctx.i18n.$gettext('Adresse des Beschafferprofils (URL)'),
                        modelValue: _ctx.organization.contact.projectUrl,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.organization.contact.projectUrl) = $event)),
                        modelModifiers: { lazy: true, trim: true }
                      }, null, 8, ["label", "modelValue"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Handelsregister-Nr.'),
                        modelValue: _ctx.organization.registrationNumber,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.organization.registrationNumber) = $event)),
                        modelModifiers: { lazy: true, trim: true }
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Zuständiges Amtsgericht (Ort)'),
                        modelValue: _ctx.organization.registrationCourt,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.organization.registrationCourt) = $event)),
                        modelModifiers: { lazy: true, trim: true }
                      }, null, 8, ["label", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_AnimatedInput, {
                        class: "mb-3",
                        type: "text",
                        label: _ctx.i18n.$gettext('Umsatzsteuer-ID'),
                        modelValue: _ctx.organization.vat,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.organization.vat) = $event)),
                        modelModifiers: { lazy: true, trim: true }
                      }, null, 8, ["label", "modelValue"])
                    ]),
                    _hoisted_39
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.step === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createVNode(_component_AnimatedInput, {
                  class: "mt-4 mb-3",
                  type: "text",
                  label: _ctx.i18n.$gettext('Vorname'),
                  modelValue: _ctx.user.contact.givenName,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.user.contact.givenName) = $event)),
                  modelModifiers: { lazy: true, trim: true },
                  required: !_ctx.userIsContact
                }, null, 8, ["label", "modelValue", "required"]),
                _createVNode(_component_AnimatedInput, {
                  class: "mb-3",
                  type: "text",
                  label: _ctx.i18n.$gettext('Nachname'),
                  modelValue: _ctx.user.contact.surName,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.user.contact.surName) = $event)),
                  modelModifiers: { lazy: true, trim: true },
                  required: !_ctx.userIsContact
                }, null, 8, ["label", "modelValue", "required"]),
                _createVNode(_component_AnimatedInput, {
                  class: "mb-3",
                  type: "email",
                  label: _ctx.i18n.$gettext('E-Mail'),
                  modelValue: _ctx.user.contact.email,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.user.contact.email) = $event)),
                  modelModifiers: { lazy: true, trim: true },
                  required: !_ctx.userIsContact
                }, null, 8, ["label", "modelValue", "required"]),
                (!_ctx.rpcClient.isInternalUser)
                  ? (_openBlock(), _createBlock(_component_AnimatedInput, {
                      key: 0,
                      class: _normalizeClass(["mb-3", { 'mt-4': _ctx.userIsContact }]),
                      type: "password",
                      label: _ctx.i18n.$gettext('Passwort'),
                      modelValue: _ctx.user.password,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.user.password) = $event)),
                      modelModifiers: { lazy: true, trim: true },
                      required: ""
                    }, null, 8, ["class", "label", "modelValue"]))
                  : _createCommentVNode("", true),
                (!_ctx.rpcClient.isInternalUser)
                  ? (_openBlock(), _createBlock(_component_AnimatedInput, {
                      key: 1,
                      class: "mb-3",
                      type: "password",
                      label: _ctx.i18n.$gettext('Passwort wiederholen'),
                      modelValue: _ctx.passwordRepeat,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.passwordRepeat) = $event)),
                      modelModifiers: { lazy: true, trim: true },
                      required: ""
                    }, null, 8, ["label", "modelValue"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.step === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("p", null, [
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Bitte überprüfen Sie Ihre Angaben noch einmal:")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("p", _hoisted_46, [
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ihr Unternehmen:")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.organization.name), 1),
                    (_ctx.organization.contact.street)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_ctx.organization.contact.street), 1))
                      : _createCommentVNode("", true),
                    (_ctx.organization.contact.street2)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(_ctx.organization.contact.street2), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_50, _toDisplayString((_ctx.organization.contact.zip || '') + ' ' + (_ctx.organization.contact.city || '')), 1),
                    (_ctx.organization.contact.country)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(_ctx.organization.contact.country), 1))
                      : _createCommentVNode("", true),
                    (_ctx.organization.contact.email)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(_ctx.organization.contact.email), 1))
                      : _createCommentVNode("", true),
                    (_ctx.organization.contact.phone)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_53, _toDisplayString(_ctx.organization.contact.phone), 1))
                      : _createCommentVNode("", true),
                    (_ctx.organization.contact.facsimile)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(_ctx.organization.contact.facsimile), 1))
                      : _createCommentVNode("", true),
                    (_ctx.organization.contact.url)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(_ctx.organization.contact.url), 1))
                      : _createCommentVNode("", true),
                    (_ctx.organization.contact.projectUrl)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(_ctx.organization.contact.projectUrl), 1))
                      : _createCommentVNode("", true),
                    (_ctx.organization.registrationNumber)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(_ctx.organization.registrationNumber), 1))
                      : _createCommentVNode("", true),
                    (_ctx.organization.registrationCourt)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_58, _toDisplayString(_ctx.organization.registrationCourt), 1))
                      : _createCommentVNode("", true),
                    (_ctx.organization.vat)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(_ctx.organization.vat), 1))
                      : _createCommentVNode("", true),
                    (_ctx.organization.nutsCode)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(_ctx.organization.nutsCode), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_61, [
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Vertretungsberechtigter:")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.organization.contact.givenName + ' ' + _ctx.organization.contact.surName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("p", _hoisted_64, [
                      _createVNode(_component_translate, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Ihr Benutzerkonto:")
                        ]),
                        _: 1
                      })
                    ]),
                    (_ctx.user.contact.givenName)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString((_ctx.user.contact.givenName || '') + ' ' + (_ctx.user.contact.surName || '')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.user.contact.email)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_66, [
                          _createVNode(_component_translate, null, {
                            default: _withCtx(() => [
                              _createTextVNode("E-Mail / Benutzername:")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(_toDisplayString(_ctx.user.contact.email), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_Checkbox, {
                      id: "confirmCheckbox1",
                      modelValue: _ctx.confirm1,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.confirm1) = $event)),
                      binary: "",
                      label: _ctx.i18n.$gettext('Ich bin vertretungsberechtigt oder handle im Auftrag des angegebenen Unternehmens.')
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_Checkbox, {
                      id: "confirmCheckbox2",
                      modelValue: _ctx.confirm2,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.confirm2) = $event)),
                      binary: "",
                      label: _ctx.i18n.$gettext('Ich versichere, dass die angegebenen Daten korrekt sind.')
                    }, null, 8, ["modelValue", "label"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.rpcClient.isInternalUser)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 2,
          to: "#breadcrumbs"
        }, [
          _createVNode(_component_Breadcrumb, {
            home: { icon: 'pi pi-home', to: '/' },
            model: _ctx.breadcrumbs
          }, null, 8, ["model"])
        ]))
      : _createCommentVNode("", true)
  ], 544))
}